import React, { useContext } from "react"
import { graphql } from "gatsby"
import Layout from "../common/layout/layout"
import LocaleContext, { LocaleProvider } from "../context/LocaleContext"
import SEO from "../common/seo/seo"
import HomeHeroSectionContainer from "../modules/homeHeroSection/HomeHeroSectionContainer"
import CalculatorsInfoSectionContainer from "../modules/calculatorsInfoSection/CalculatorsInfoSectionContainer"
import HealthyLifeSection from "../modules/healthyLifeSection/HealthyLifeSection"
import ReviewsSliderContainer from "../modules/reviewsSlider/ReviewsSliderContainer"
import HomeBlogPostsContainer from "../modules/homeBlogPosts/HomeBlogPostsContainer"
import HomeConsultationContainer from "../modules/homeConsultation/HomeConsultationContainer"
import ForDiabetesSection from "../modules/forDiabetesSection/ForDiabetesSection"
import translate, { keys } from "../translation/translator"
// import loadable from "@loadable/component"
// const SEO = loadable(() => import(`../common/seo/seo`))

// const HomeHeroSectionContainer = loadable(() =>
//   import(`../modules/homeHeroSection/HomeHeroSectionContainer`)
// )
// const CalculatorsInfoSectionContainer = loadable(() =>
//   import(`../modules/calculatorsInfoSection/CalculatorsInfoSectionContainer`)
// )
// const HealthyLifeSection = loadable(() =>
//   import(`../modules/healthyLifeSection/HealthyLifeSection`)
// )
// const ReviewsSliderContainer = loadable(() =>
//   import(`../modules/reviewsSlider/ReviewsSliderContainer`)
// )
// const HomeBlogPostsContainer = loadable(() =>
//   import(`../modules/homeBlogPosts/HomeBlogPostsContainer`)
// )
// const HomeConsultationContainer = loadable(() =>
//   import(`../modules/homeConsultation/HomeConsultationContainer`)
// )
// const ForDiabetesSection = loadable(() =>
//   import(`../modules/forDiabetesSection/ForDiabetesSection`)
// )

const IndexPage = ({ data }) => {
  const locale = useContext(LocaleContext)
  console.log(locale)
  return (
    <LocaleProvider>
      <Layout>
        <SEO
          title={translate(keys.HOME_PAGE_META_TITLE, locale)}
          description={translate(keys.HOME_PAGE_META_DESCRIPTION, locale)}
        />
        <HomeHeroSectionContainer images={data.homePageImages.edges} />
        <CalculatorsInfoSectionContainer />
        <HealthyLifeSection />
        <ReviewsSliderContainer images={data.reviewsImages.edges} />
        <HomeBlogPostsContainer blogs={data.blogs.edges} />
        <HomeConsultationContainer />
        <ForDiabetesSection />
      </Layout>
    </LocaleProvider>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }

    homePageImages: allFile(
      filter: { relativeDirectory: { eq: "homePageImages" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 500, quality: 90) {
              ...GatsbyImageSharpFluid
            }
            id
          }
        }
      }
    }

    reviewsImages: allFile(
      filter: { relativeDirectory: { eq: "reviewsImages" } }
    ) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 300, quality: 90) {
              ...GatsbyImageSharpFluid
            }
            id
          }
        }
      }
    }

    blogs: allContentfulPosts(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          id
          slug
          title
          date(formatString: "DD MMMM YYYY")
          intro {
            content {
              nodeType
              content {
                value
              }
            }
          }
          author {
            id
            name
            slug
            email
            avatar {
              fluid(maxWidth: 200, quality: 100) {
                ...GatsbyContentfulFluid_withWebp
              }
            }
          }
          mainImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
        }
      }
    }
  }
`
